// eslint-disable-next-line import/prefer-default-export
export const PALATTE_PRIMARY_MAIN_COLOR = "#012169";
export const PALATTE_SECONDARY_MAIN_COLOR = "#F9EECF";
export const PALATTE_ERROR_MAIN_COLOR = "#B31913";
export const TEXT_PRIMARY_COLOR = "#011136";
export const TEXT_SECONDARY_COLOR = "#676767";
export const DISABLED_COLOR = "#E6E6E6";
export const PALATTE_WARNING_MAIN_COLOR = "#ed6c02";
export const PALATTE_SUCCESS_BRIGHT = "#357a38";
